const numberMillion = 1000000;
const numberThousand = 1000;
/**
 * Formats a number that exceeds a thousand or a million.
 *
 * @example
 *   formatAbbreviateNumber(100) -> 100
 *
 * @example
 *   formatAbbreviateNumber(1000) -> 1K
 *
 * @example
 *   formatAbbreviateNumber(1200) -> 1.2K (Europe) or 1,2K (US)
 *
 * @example
 *   formatAbbreviateNumber(1000000) -> 1M
 *
 * @example
 *   formatAbbreviateNumber(1500000) -> 1.5M (Europe) or 1,5M (US)
 *
 * @param num The number that should be abbreviated.
 */
export function formatAbbreviateNumber(num) {
    if (num < numberThousand)
        return `${num}`;
    const isMillion = num >= numberMillion;
    const value = parseFloat((num / (isMillion ? numberMillion : numberThousand)).toFixed(1));
    const unit = isMillion ? 'M' : 'K';
    return `${value}${unit}`;
}
/**
 * Formats the numbers that are in thousands, millions or larger with localized
 * separator.
 *
 * @example
 *   formatLocalizedNumber(100) -> 100
 *
 * @example
 *   formatLocalizedNumber(1000) -> 1.000 (Europe) or 1,000 (US)
 *
 * @example
 *   formatLocalizedNumber(1000000) -> 1.000.000 (Europe) or 1,000,000 (US)
 *
 * @param num The number that should be formatted.
 */
export function formatLocalizedNumber(num) {
    return num.toLocaleString(navigator.language);
}
